import $ from "jquery";

function loadImages($images) {
  $images.each(function() {
    $(this).attr("src", $(this).data("src"));
  });
}

const lp_logos = function() {
  loadImages($(".no-lazyload"));

  $(".js-lp-logos").css(
    "animation-duration",
    $(".js-lp-logos").children().length + "s"
  );
};

export default lp_logos;
